import api from './api';
import { downloadBlobResponse } from '../utils/reportExport';

// Clients Service
export const clientsService = {
    list: (params = {}) => {
        return api.get('/clients', { params });
    },
    get: (id) => {
        return api.get(`/clients/${id}`);
    },
    create: (data) => {
        return api.post('/clients', data);
    },
    update: (id, data) => {
        return api.put(`/clients/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`/clients/${id}`);
    },
};

export const clientTypesService = {
    list: (params = {}) => {
        return api.get('/client-types', { params });
    },
    get: (id) => {
        return api.get(`/client-types/${id}`);
    },
    create: (data) => {
        return api.post('/client-types', data);
    },
    update: (id, data) => {
        return api.put(`/client-types/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`/client-types/${id}`);
    },
};

// Sales (Pedidos) Service
export const salesService = {
    stats: () => {
        return api.get('/sales/stats');
    },
    list: (params = {}) => {
        return api.get('/sales', { params });
    },
    get: (id) => {
        return api.get(`/sales/${id}`);
    },
    create: (data) => {
        return api.post('/sales', data);
    },
    update: (id, data) => {
        return api.put(`/sales/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`/sales/${id}`);
    },
    approve: (id) => {
        return api.post(`/sales/${id}/approve`);
    },
    cancel: (id) => {
        return api.post(`/sales/${id}/cancel`);
    },
    finish: (id) => {
        return api.post(`/sales/${id}/finish`);
    },
    createDelivery: (id, data) => {
        return api.post(`/sales/${id}/deliveries`, data);
    },
    nextNumber: () => {
        return api.get('/sales/next-number');
    },
    downloadPdf: (id, documentNumber) => {
        return downloadSalePdf(`/sales/${id}/pdf`, `pedido-${documentNumber ?? id}.pdf`);
    },
    downloadDeliveryPdf: (id, deliveryId, documentNumber) => {
        return downloadSalePdf(
            `/sales/${id}/deliveries/${deliveryId}/pdf`,
            `atendimento-${documentNumber ?? id}-${deliveryId}.pdf`
        );
    },
};

async function downloadSalePdf(url, filename) {
    try {
        await downloadBlobResponse(api.get(url, { responseType: 'blob' }), filename, 'application/pdf');
    } catch (e) {
        // Com responseType blob o corpo do erro também vem como Blob; converte para JSON.
        if (e?.response?.data instanceof Blob) {
            try {
                e.response.data = JSON.parse(await e.response.data.text());
            } catch (_) {
                e.response.data = null;
            }
        }
        throw e;
    }
}

// Available stock helper (per product, optionally per warehouse)
export const stockAvailabilityService = {
    get: (productId, warehouseId) => {
        const params = warehouseId ? { warehouse_id: warehouseId } : {};
        return api.get(`/products/${productId}/available-stock`, { params });
    },
};
